import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const TicketOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m8.818 7.807 1.047 1.047m5.233 5.233 1.047 1.047m-4.187-4.187 1.047 1.047m-9.42 5.233c.53-.53 1.204-.873 1.873-.953s1.279.108 1.695.525c.417.416.605 1.026.525 1.695-.08.67-.423 1.343-.953 1.873l1.047 1.047c.277.277.684.403 1.13.35s.895-.283 1.248-.636l10.657-10.657c.353-.353.582-.802.636-1.248.053-.446-.073-.853-.35-1.13l-1.047-1.047c-.53.53-1.204.873-1.873.953s-1.279-.109-1.695-.525-.605-1.026-.525-1.695c.08-.67.423-1.343.953-1.873l-1.047-1.047c-.277-.277-.684-.403-1.13-.35s-.895.282-1.248.636L2.824 13.802c-.353.353-.582.802-.636 1.248-.053.446.073.853.35 1.13z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(TicketOutline) as SvgIcon;
export { ForwardRef as ReactComponent };
